// extracted by mini-css-extract-plugin
export default {"wrapper":"section-divider-block-module--wrapper--b0bce","divider":"section-divider-block-module--divider--a2350","innerWrapper":"section-divider-block-module--innerWrapper--9c6d1"};